<template>
  <div class="content no-flex active">
    <div class="invoice-email-form">
      <!-- Sender -->
      <div>
        <p class="email-label">Sender</p>
        <p>{{ emailData.FromEmail }} {{ emailData.NameSender }}</p>
      </div>

      <!-- Subject -->
      <div>
        <p class="email-label">Subject</p>
        <p>{{ emailData.Subject }}</p>
      </div>

      <!-- Date -->
      <div>
        <p class="email-label">Date</p>
        <p>{{ formatDate(emailData.ReceivedDate) }}</p>
      </div>

      <!-- Body -->
      <div>
            <p class="email-label">Body</p>
                <div class="email-body" v-html="emailData.OriginalBodyHtml"></div>
      </div>
    </div>

    <!-- Footer -->
    <div class="footer-section">
      <button type="button" class="btn btn-primary" @click="closeWindow">
        CLOSE
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      emailData: {}
    }
  },
  created() {
    const invoiceId = this.$route.query.invoiceId
    if (!invoiceId) {
      console.warn('Invoice ID is missing')
      return
    }

    this.api.get(`${this.api.$.invoice.reviewEmail}/${invoiceId}`)
      .then(response => {
        this.emailData = response.data
      })
      .catch(ex => console.error('Error fetching review email:', ex))
  },
  methods: {
    closeWindow() {
      window.close()
    },
    formatDate(dateString) {
      if (!dateString) return ''
      const timestamp = parseInt(dateString.match(/\d+/)[0], 10)
      return new Date(timestamp).toLocaleString()
    }
  }
}
</script>


<style lang="scss" scoped>
.invoice-email-form {
  text-align: left !important;
}

.email-label {
  font-weight: bold;
  font-size: 1em;
}

.email-list {
  list-style-type: disc;    
  padding-left: 20px;
  margin: 0;
  background: #f5f6fa;
  border-radius: 6px;

}
</style>



// WEBPACK FOOTER //
// src/components/_modules/I2P/ReviewEmailPage.vue